import React from 'react'

import validation from '../../../validation'
import SmartAddressInput from '../../common/SmartAddressInput'
import PhoneInput from '../../controls/PhoneInput'

export default {
  name: 'Attorney',
  group: 'Claimant',
  sectionNumber: 2,
  validationSchema: getValidationSchema(),
  Component,
}

function getValidationSchema() {
  // Plaintiff and defendant info — no fields are required in this section
  return validation.object({})
}

function Component({ caseModel, createInputProps, getValue, setModelValue, ErrorMessage }) {
  return (
    <div>
      <h3 className="pb-3">Attorney Information</h3>
      <h5 className="form-heading mb-4">Plaintiff</h5>
      <div className="form-row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label mt-3" htmlFor="plaintiff.name">
              Company Name
            </label>
            <input
              type="text"
              {...createInputProps('plaintiff.name')}
              className="form-control"
              maxLength={validation.maxLengths.name}
            />
            <ErrorMessage name="plaintiff.name" />
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="col-12">
          <label className="form-label mt-2">Address</label>
          <SmartAddressInput
            value={{
              street: caseModel.plaintiff?.address?.line1 ?? '',
              city: caseModel.plaintiff?.address?.city ?? '',
              state: caseModel.plaintiff?.address?.state ?? '',
              zip: caseModel.plaintiff?.address?.zip ?? '',
            }}
            onChange={newAddr => {
              setModelValue('plaintiff.address.line1', newAddr.street)
              setModelValue('plaintiff.address.city', newAddr.city)
              setModelValue('plaintiff.address.state', newAddr.state)
              setModelValue('plaintiff.address.zip', newAddr.zip)
            }}
            // ErrorMessage component in this file doesn't seem to expose raw errors easily?
            // "ErrorMessage" passed in prop is likely a wrapper that looks up error by name.
            // SmartAddressInput expects an 'error' object with keys 'street', 'city', etc.
            // If we can't get raw errors easily, we might pass empty object or try to peek.
            // In these sections, validation might be handled by parent or context.
            // Let's assume for now we don't pass explicit error object unless validation object is available.
            // AttorneySection doesn't seem to receive 'errors' prop in destructuring?
            // Actually, Sections.js doesn't show props passed.
            // ReferralSection doesn't use SmartAddressInput so it doesn't show pattern.
            // We'll leave error undefined for now, or check if we can get it.
          />
        </div>
      </div>
      <div>
        <ErrorMessage name="plaintiff.address.city" />
        <ErrorMessage name="plaintiff.address.state" />
        <ErrorMessage name="plaintiff.address.zip" />
      </div>
      <div className="form-row">
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="plaintiff.contact.phone">
              Phone
            </label>
            <PhoneInput
              {...createInputProps('plaintiff.contact.phone')}
              className="form-control"
              placeholder="(123) 456-7890"
            />
            <ErrorMessage name="plaintiff.contact.phone" />
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="plaintiff.contact.fax">
              Fax
            </label>
            <PhoneInput
              {...createInputProps('plaintiff.contact.fax')}
              className="form-control"
              placeholder="(123) 456-7890"
            />
            <ErrorMessage name="plaintiff.contact.fax" />
          </div>
        </div>
      </div>
      <div>
        <label className="form-label mt-3" htmlFor="plaintiff.contact.firstName">
          Contact Name
        </label>
        <div className="form-row">
          <div className="col-md-3">
            <div className="form-group">
              <input
                type="text"
                {...createInputProps('plaintiff.contact.firstName')}
                className="form-control"
                maxLength={validation.maxLengths.name}
                placeholder="First Name"
              />
              <ErrorMessage name="plaintiff.contact.firstName" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <input
                type="text"
                {...createInputProps('plaintiff.contact.lastName')}
                className="form-control"
                placeholder="Last Name"
                maxLength={validation.maxLengths.name}
              />
              <ErrorMessage name="plaintiff.contact.lastName" />
            </div>
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="plaintiff.contact.email">
              Email
            </label>
            <input
              type="email"
              {...createInputProps('plaintiff.contact.email')}
              className="form-control"
              placeholder="name@email.com"
              maxLength={validation.maxLengths.email}
            />
            <ErrorMessage name="plaintiff.contact.email" />
          </div>
        </div>
      </div>

      <h5 className="form-heading mt-4 mb-4">Defendant</h5>
      <div className="form-row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label mt-3" htmlFor="defendant.name">
              Company Name
            </label>
            <input
              type="text"
              {...createInputProps('defendant.name')}
              className="form-control"
              maxLength={validation.maxLengths.name}
            />
            <ErrorMessage name="defendant.name" />
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="col-12">
          <label className="form-label mt-2">Address</label>
          <SmartAddressInput
            value={{
              street: caseModel.defendant?.address?.line1 ?? '',
              city: caseModel.defendant?.address?.city ?? '',
              state: caseModel.defendant?.address?.state ?? '',
              zip: caseModel.defendant?.address?.zip ?? '',
            }}
            onChange={newAddr => {
              setModelValue('defendant.address.line1', newAddr.street)
              setModelValue('defendant.address.city', newAddr.city)
              setModelValue('defendant.address.state', newAddr.state)
              setModelValue('defendant.address.zip', newAddr.zip)
            }}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="defendant.contact.phone">
              Phone
            </label>
            <PhoneInput
              {...createInputProps('defendant.contact.phone')}
              className="form-control"
              placeholder="(123) 456-7890"
            />
            <ErrorMessage name="defendant.contact.phone" />
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="defendant.contact.fax">
              Fax
            </label>
            <PhoneInput
              {...createInputProps('defendant.contact.fax')}
              className="form-control"
              placeholder="(123) 456-7890"
            />
            <ErrorMessage name="defendant.contact.fax" />
          </div>
        </div>
      </div>
      <div>
        <label className="form-label mt-3" htmlFor="defendant.contact.firstName">
          Contact Name
        </label>
        <div className="form-row">
          <div className="col-md-3">
            <div className="form-group">
              <input
                type="text"
                {...createInputProps('defendant.contact.firstName')}
                className="form-control"
                maxLength={validation.maxLengths.name}
                placeholder="First Name"
              />
              <ErrorMessage name="defendant.contact.firstName" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <input
                type="text"
                {...createInputProps('defendant.contact.lastName')}
                className="form-control"
                placeholder="Last Name"
                maxLength={validation.maxLengths.name}
              />
              <ErrorMessage name="defendant.contact.lastName" />
            </div>
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="defendant.contact.email">
              Email
            </label>
            <input
              type="email"
              {...createInputProps('defendant.contact.email')}
              className="form-control"
              placeholder="name@email.com"
              maxLength={validation.maxLengths.email}
            />
            <ErrorMessage name="defendant.contact.email" />
          </div>
        </div>
      </div>
    </div>
  )
}
